import { Pagination } from '@design-system';
import { FC } from 'react';

import { Franchises } from '../../types/Franchises';
import { getWordCount } from '../../utils/journals/franchises';
import { readingTimeCalculator } from '../../utils/readingTimeCalculator';
import { JournalsCard } from './JournalsCard';

interface JournalsGridProps {
  franchise: string;
  handleClick: (story: Franchises, index: number) => void;
  handlePaginationClick: (page: number) => void;
  pagination: {
    page: number;
    perPage: number;
    total: number;
  };
  stories: Franchises[];
}

export const JournalsGrid: FC<JournalsGridProps> = ({
  franchise,
  handleClick,
  handlePaginationClick,
  pagination,
  stories,
}) => (
  <>
    <main className="grid-section gap-y-6">
      {stories.map((story, index) => (
        <article
          key={story.uuid}
          className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3"
        >
          <JournalsCard
            description={story.content.subtitle}
            eagerLoading={index < 1}
            href={`/insights/${franchise}/${story.slug}`}
            image={story.content.poster}
            imageRatio={story.content.posterRatio}
            mediaDuration={story.content.mediaDuration}
            onClick={() => {
              handleClick(story, index);
            }}
            publishedAt={story.content.date}
            readingTime={readingTimeCalculator(
              getWordCount(story.content.article),
            )}
            tag={story.content.tag}
            title={story.content.title}
          />
        </article>
      ))}
    </main>

    {Math.ceil(pagination.total / pagination.perPage) > 1 && (
      <div className="col-span-12 pt-3 md:pt-6">
        <Pagination
          currentPage={pagination.page}
          handleOnClick={handlePaginationClick}
          numPages={Math.ceil(pagination.total / pagination.perPage)}
          paginationUrl={`/insights/${franchise}`}
          queryParams=""
        />
      </div>
    )}
  </>
);
